export function SectionHeader(props) {
    return (
        <>
            <div className="divider"/>
            <h2 className="section-title">{props.title}</h2>
            <p className={props.isKontak ? "section-sub-kontakt" : "section-sub"}>{props.sub}</p>
        </>
    );
}